export default __webpack_public_path__ + "static/advance-payment-platform-digipay-plus-527ef9308b12cdbfc8f694aec4841564.png";